import { GridContainer } from 'libs/ui';
import { Ride } from 'grids/ride/ride';

export const PlateRideWrapper = (props) => {
  return (
    <GridContainer>
      <Ride {...props} isPlate={true} />
    </GridContainer>
  );
};
